import './verifyPayment.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { bookingStatus } from '../../api/bookingOrgApi';

export default function VerifyPayment() {
    const [showRetry, setShowRetry] = useState(false);
    const navigate = useNavigate();

    // bookingId from URL or fallback from localStorage
    const bookedData = JSON.parse(localStorage.getItem('bookedData'));

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowRetry(true);
        }, 180000); // 3 minutes = 180000 ms

        return () => clearTimeout(timer); // cleanup on unmount
    }, []);

    useEffect(() => {
        if (bookedData === null) return;
        if (!bookedData?.bookingId) {
            navigate('/h/review-booking');
            return;
        }

        const checkInterval = 3000; // 3 sec
        const timeoutLimit = 600000; // 10 min

        let intervalId;

        // Timeout → return to review booking
        const timeoutId = setTimeout(() => {
            clearInterval(intervalId);
            navigate('/h/review-booking');
        }, timeoutLimit);

        // Polling function
        intervalId = setInterval(async () => {
            try {
                const res = await bookingStatus('trip', bookedData?.bookingId);

                const paymentState = res?.data?.paymentInfo?.status;

                if (paymentState === 'Paid') {
                    clearInterval(intervalId);
                    clearTimeout(timeoutId);
                    localStorage.setItem('backendBookingData', JSON.stringify({ ...res?.data }));
                    navigate('/h/booking-confirmation');
                } else if (paymentState === 'Failed') {
                    clearInterval(intervalId);
                    clearTimeout(timeoutId);
                    navigate('/h/review-booking');
                }
            } catch (error) {
                console.error('Polling failed:', error);
            }
        }, checkInterval);

        // Cleanup on component unmount
        return () => {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
        };
        //eslint-disable-next-line
    }, [bookedData?.bookingId, navigate]);

    return (
        <div style={{ textAlign: 'center', marginTop: '70px' }}>
            <div className='loadingBackgroundPayment'>
                <ReactLoading type='spin' color='#006aff' className='loadingSpinPayment' />
                <p className='loadingText'>Please wait while we verify your payment…</p>
                {showRetry && (
                    <div style={{ marginTop: '30px' }}>
                        <button
                            onClick={() => navigate(`/review-booking`)}
                            style={{
                                padding: '10px 15px',
                                background: '#006aff',
                                color: 'white',
                                borderRadius: '6px',
                                marginRight: '10px',
                                border: 'none',
                                cursor: 'pointer'
                            }}
                        >
                            Click to retry payment
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
